import { Box, Skeleton, Stack } from "@mui/material";
import styles from "./WaitingPage.module.css";

export default function WaitingSkeleton() {
	return (
		<div className={styles.body}>
			<Stack gap="80px">
				<Skeleton variant="rectangular" width="100%" height={74} />

				<Stack gap="25px" alignItems="center">
					<Box>
						<Skeleton variant="circular" width={100} height={100} />
					</Box>

					<Skeleton variant="text" width={400} height={24} />
					<Stack width="100%" alignItems="center">
						<Skeleton variant="text" width="100%" height={20} />
						<Skeleton variant="text" width="60%" height={20} />
					</Stack>

					<Skeleton variant="rectangular" width={160} height={38} />
				</Stack>
			</Stack>
		</div>
	);
}
